module.exports = __webpack_public_path__ + "img/product19.ac3a7ee6.png";